import {
  AUTH_ALL,
  AUTH_CREATOR,
  AUTH_ID_ADMIN,
  AUTH_ID_ALL,
  PRIVILEDGE_STORAGE_KEY
} from '@merchant-backend/constant'
import {
  PRODUCT_INVITATION_CARD,
  PRODUCT_JUKE,
  PRODUCT_MICRO_WEBSITE,
  PRODUCT_MV_CARD,
  PRODUCT_NAME_CARD,
  PRODUCT_WECHAT_WEAPP,
  SHOP_PRODUCTS_PATH
} from '@constant'
import { isOnlineShop, isUltimate } from '@merchant-backend/util'
import { getProTitle } from '../system'
import { Modal } from 'hljd'
import { hashHistory } from 'react-router'

/**
 * 权限id列表
 */
export const getAuthIdList = () => {
  return JSON.parse(sessionStorage.getItem(PRIVILEDGE_STORAGE_KEY) || '[]')
}

/**
 * 是否是客服账号
 */
export const isRoleService = () => {
  const authIdList = getAuthIdList()
  const is = !(
    authIdList.includes(AUTH_CREATOR) ||
    authIdList.includes(AUTH_ALL) ||
    authIdList.includes(AUTH_ID_ALL) ||
    authIdList.includes(AUTH_ID_ADMIN) ||
    authIdList.includes(AUTH_ALL)
  )
  return is
}
/**
 * 是否是超级管理员
 */
export const isSuperAdmin = () => {
  const authIdList = getAuthIdList()
  return (
    authIdList.includes(AUTH_CREATOR) ||
    authIdList.includes(AUTH_ALL) ||
    authIdList.includes(AUTH_ID_ALL) ||
    authIdList.includes(AUTH_ID_ADMIN)
  )
}

/**
 * 具有管理和配置中心-员工管理权限的角色
 */
export const hasStaffAuth = () => {
  const authCodes = JSON.parse(
    sessionStorage.getItem('MERCHANT_CENTER_AUTH_CODES') || '[]'
  )
  const is = authCodes && authCodes.includes('0_1_2_3')
  return is
}
/**
 * 是否具备商家中心-运营管理权限
 */

export const isOperateManage = () => {
  const authIdList = getAuthIdList()
  return !(
    authIdList.includes(AUTH_CREATOR) ||
    authIdList.includes(AUTH_ID_ALL) ||
    authIdList.includes(AUTH_ID_ADMIN)
  )
}

export const hasAuthByProductId = id => {
  switch (id) {
    case PRODUCT_MICRO_WEBSITE:
      return isOnlineShop() || isUltimate()
    case PRODUCT_WECHAT_WEAPP:
      return isOnlineShop() || isUltimate()
    case PRODUCT_JUKE:
      return isUltimate()
    case PRODUCT_NAME_CARD:
      return isOnlineShop() || isUltimate()
    case PRODUCT_INVITATION_CARD:
      return isOnlineShop() || isUltimate()
    case PRODUCT_MV_CARD:
      return isOnlineShop() || isUltimate()
  }
}

/**
 * 开通旗舰版/尊享版通用弹窗确认框
 */
export const openProModal = () => {
  const title = getProTitle()
  Modal.confirm({
    title: `无法使用此功能，请升级${title}`,
    okText: `开通${title}`,
    cancelText: '关闭',
    onOk: () => {
      hashHistory.push(SHOP_PRODUCTS_PATH)
    }
  })
}
